// extracted by mini-css-extract-plugin
export var brand = "_19-9";
export var button = "_19-0";
export var chevron = "_19-v";
export var chevronButton = "_19-w";
export var content = "_19-n";
export var danger = "_19-g";
export var dangerOutlined = "_19-h";
export var dark = "_19-l";
export var darkTheme = "_19-c";
export var extraSmall = "_19-4";
export var fullWidth = "_19-8";
export var ghost = "_19-d";
export var gray = "_19-t";
export var icon = "_19-p";
export var iconButton = "_19-s";
export var iconButtonBorder = "_19-x";
export var iconButtonBorderDark = "_19-y";
export var iconButtonBorderLight = "_19-z";
export var iconLeft = "_19-q";
export var iconRight = "_19-r";
export var large = "_19-1";
export var light = "_19-m";
export var medium = "_19-2";
export var micro = "_19-5";
export var nano = "_19-7";
export var outlined = "_19-k";
export var pending = "_19-a";
export var primary = "_19-i";
export var shadow = "_19-o";
export var small = "_19-3";
export var solidLight = "_19-e";
export var solidLightBrand = "_19-f";
export var spinner = "_19-u";
export var transparent = "_19-j";
export var warning = "_19-b";
export var wideNano = "_19-6";